import { render, staticRenderFns } from "./EditBL.vue?vue&type=template&id=4df4905a&lang=html&"
import script from "./EditBL.vue?vue&type=script&lang=js&"
export * from "./EditBL.vue?vue&type=script&lang=js&"
import style0 from "./EditBL.vue?vue&type=style&index=0&id=4df4905a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports